<template>
  <div class="products_manage">
    <div style="margin-bottom:20px;">
      <h1 style="text-align:left;">产品管理</h1>
      <el-divider></el-divider>
    </div>
    <div>
      <a href="/manageProducts">
        <el-button type="primary" icon="el-icon-plus">添加产品</el-button>
      </a>
      <!-- 修改产品弹窗 -->
      <div>
        <el-dialog title="修改产品" :visible.sync="dialogFormVisible" :before-close="close">
          <el-form :model="form">
            <el-form-item label="产品名称" :label-width="formLabelWidth">
              <el-input v-model="form.product_name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="产品类型" :label-width="formLabelWidth">
              <el-select v-model="form.type" placeholder="产品类型">
                <el-option
                  v-for="option in product_typs"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品图片" :label-width="formLabelWidth">
              <el-upload
                action="/product_figure.php"
                show-file-list="true"
                list-type="picture-card"
                :file-list="fileList"
                :on-success="handleAvatarSuccess"
                :on-remove="delete_file"
                :data="{id:form.id}"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="简介" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="form.pro_int" :rows="10"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false;fileList = [];">取 消</el-button>
            <el-button type="primary" @click="modify_product">修 改</el-button>
          </div>
        </el-dialog>
      </div>
      <el-dialog title="修改产品种类" :visible.sync="modify_layer" width="30%">
        <el-form :model="pro_ty">
          <el-form-item label="产品名称" :label-width="formLabelWidth">
            <el-input v-model="pro_ty.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modify_layer = false;pro_ty = [];">取 消</el-button>
          <el-button type="primary" v-on:click="modify_product_type">修 改</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="content">
      <div class="fl">
        <ul class="items">
          <li
            v-for="(product,index) in items"
            :key="product.id"
            v-on:click="showProducts(product.id,index)"
            v-on:mouseenter="show_btn($event)"
            v-on:mouseleave="hide_btn($event)"
            :class="{active:currType===index}"
          >
            <span>{{product.name}}</span>
            <div style="float:right;display:none;">
              <i
                class="el-icon-edit"
                style="margin:0 5px;"
                v-on:click.stop="modify_layer=true;pro_ty.id=product.id;pro_ty.name=product.name;curr_modify_pro_id=product.id"
              ></i>
              <i
                class="el-icon-delete"
                style="margin:0 5px;"
                v-on:click.stop="remove_class(product.id,items,index)"
              ></i>
            </div>
          </li>
        </ul>
      </div>
      <div class="fr">
        <el-table :data="tableData" style="width: 100%" stripe>
          <el-table-column label="id" width="180">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" width="180">
            <template slot-scope="scope">{{scope.row.product_name}}</template>
          </el-table-column>
          <el-table-column label="产品种类" width="180">
            <template slot-scope="scope">{{scope.row.type}}</template>
          </el-table-column>
          <el-table-column label="图片" width="180">
            <template slot-scope="scope">{{scope.row.images}}</template>
          </el-table-column>
          <el-table-column label="简介" width="180">
            <template slot-scope="scope">{{scope.row.pro_int}}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row,tableData)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <v-pagination
          :total="total"
          v-on:prev="prev"
          v-on:next="next"
          v-on:changePage="changePage"
          v-if="total>0"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>
<style scoped>
.content {
  width: 100%;
  height: 100%;
  margin: 15px 0;
  position: relative;
}
.active {
  color: #409eff;
}
.fl {
  width: 200px;
  height: 100px;
  float: left;
  position: absolute;
  left: 0;
  top: 0;
}
.fr {
  width: 80%;
  height: 100px;
  position: absolute;
  left: 240px;
  top: 0;
}
.items {
  width: 100%;
  height: 100%;
}
.items li {
  width: 100%;
  height: 48px;
  border-bottom: 1px solid #f2f2f2;
  line-height: 48px;
  padding: 0px 5px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 14px;
}
.items li:hover {
  background-color: #ccc;
}
</style>
<script>
export default {
  name: "productsManage",
  data() {
    return {
      currType: 0,
      curr_modify_pro_id: null,
      items: [],
      tableData: [],
      total: 0,
      dialogFormVisible: false,
      modify_layer: false,
      show: false,
      formLabelWidth: "120px",
      fileList: [],
      form: {
        id: 1,
        product_name: null,
        type: 2,
        pro_int: "",
        images: []
      },
      pro_ty: {
        id: null,
        name: null
      },
      product_typs: [],
      currProductId: null
    };
  },
  methods: {
    show_btn(event) {
      var elem = event.target;
      $(elem)
        .find("div")
        .show();
      console.log(elem);
    },
    hide_btn(event) {
      var elem = event.target;
      $(elem)
        .find("div")
        .hide();
    },
    modify_product_type() {
      var self = this;
      this.ajax(
        "/product_type.php",
        "patch",
        JSON.stringify(this.pro_ty),
        function(data) {
          self.modify_layer = false;
          self.items.find((x, y) => {
            if (x.id == self.curr_modify_pro_id) {
              x.name = self.pro_ty.name;
            }
          });
        }
      );
    },
    remove_class(id, rows, index) {
      var self = this;
      this.$confirm("是否删除该产品种类和产品种类包含的产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ajax("/product_type.php?id=" + id, "delete", null, function(
            data
          ) {
            rows.splice(index, 1);
            self.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {});
    },
    close() {
      this.dialogFormVisible = false;
      this.fileList = [];
    },
    prev() {
      this.getProducts(page);
    },
    next() {
      this.getProducts(page);
    },
    changePage(page) {
      this.getProducts(page);
    },
    getProducts(page) {
      var self = this;
      this.$ajax(
        `/products.php?id=${self.currProductId}&page=${page}`,
        "get",
        null,
        function(data) {
          var da = JSON.parse(data);
          self.tableData = da.products;
          self.total = da.total;
        }
      );
    },
    modify_product() {
      var data = this.form;
      var self = this;
      this.ajax("/products.php", "patch", JSON.stringify(data), function(data) {
        self.dialogFormVisible = false;
        self.$message({
          type: "success",
          message: "修改成功!"
        });
        self.$ajax(
          `/products.php?id=${self.currProductId}&page=1`,
          "get",
          null,
          function(data) {
            var da = JSON.parse(data);
            self.tableData = da.products;
            self.total = da.total;
          }
        );
      });
    },
    handleAvatarSuccess(response, file, fileList) {
      this.form.images.push(response.replace(/\s/g, ""));
    },
    delete_file(file, fileList) {
      var data = {
        id: file.id,
        path: file.name
      };
      this.ajax("/product_figure.php", "delete", JSON.stringify(data), function(
        data
      ) {});
    },
    /** 显示该商品种类的所有商品 */
    showProducts(id, index) {
      this.currType = index;
      this.currProductId = id;
      var _this = this;
      this.$ajax(`/products.php?id=${id}&page=1`, "get", null, function(data) {
        var da = JSON.parse(data);
        _this.tableData = da.products;
        _this.total = da.total;
      });
    },
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.form = row;
      this.fileList = [];

      for (let i = 0; i < row.images.length; i++) {
        var img = row.images[i];
        this.fileList.push({
          id: img.id,
          name: img.path,
          url: "/" + img.path
        });
      }
    },
    handleDelete(index, row, rows) {
      var self = this;
      this.$confirm("是否删除该产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ajax("/products.php?id=" + row.id, "delete", null, function(
            data
          ) {
            rows.splice(index, 1);
            self.total = self.total - 1;
            self.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    var _this = this;
    $.ajax({
      url: "/getAllPro.php",
      type: "get",
      data: null,
      success: function(data, textStatus, jqXHR) {
        _this.items = JSON.parse(data);
      }
    });
    $.ajax({
      url: "/product_type.php",
      type: "get",
      success: function(data, textStatus, jqXHR) {
        _this.product_typs = JSON.parse(data);
        if (_this.product_typs.length > 0) {
          _this.currProductId = _this.product_typs[0].id;
          _this.$ajax(
            `/products.php?id=${_this.currProductId}&page=1`,
            "get",
            null,
            function(data) {
              var da = JSON.parse(data);
              _this.tableData = da.products;
              _this.total = da.total;
            }
          );
        }
      }
    });
  }
};

/**
 * 需要新增修改商品api 删除商品api
 * 完善添加商品
 *
 * 

 */
</script>





// WEBPACK FOOTER //
// src/components/products_manage.vue